'use client'

import { useMemo } from 'react'
import useSWRImmutable from 'swr/immutable'
import type { Labels, LabelsNamespaces } from 'types/labels'
import { env } from 'utils/envManager'

import { fetchLabels } from '../../services'

interface UseClientLabelsKeysProps {
	keys: string[]
	namespaces?: LabelsNamespaces[]
}

interface UseClientLabelsNamespacesProps {
	keys?: string[]
	namespaces: LabelsNamespaces[]
}

type UseClientLabelsProps = (
	| UseClientLabelsKeysProps
	| UseClientLabelsNamespacesProps
) & {
	countryISO: string
	languageISO: string
	suspense?: boolean
}

export function useClientLabels({
	keys,
	namespaces,
	countryISO,
	languageISO,
	suspense = true,
}: UseClientLabelsProps): {
	labels: Labels | null | undefined
	t: (key: string) => string
} {
	const doFetch = (namespaces ?? []).length !== 0 || (keys ?? []).length !== 0

	const { data } = useSWRImmutable(
		[keys, namespaces],
		() =>
			doFetch
				? fetchLabels({
						keys,
						namespaces,
						service: `${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-labels`,
						country: countryISO,
						language: languageISO,
					})
				: null,
		{ suspense }
	)

	return useMemo(
		() => ({ labels: data, t: (key: string) => data?.[key] || key }),
		[data]
	)
}
